export let SHARE_MODES = /*#__PURE__*/function (SHARE_MODES) {
  SHARE_MODES["CHANNEL"] = "channel";
  SHARE_MODES["VIDEO"] = "video";
  return SHARE_MODES;
}({});
//# sourceMappingURL=constants.js.map